import axios from "axios";
import { GetEnvironmentConfig } from  '../../App.Config';

export const getVersionNumberAsync = async ():Promise<any> => {
    let endpoint = GetEnvironmentConfig().endpoints.status_api;
    const request = await axios.get(`${endpoint}/api/v1/appinfo`);
    return request;
}